import classnames from 'classnames';
export default function Section({
  children,
  className,
  id = false,
}) {
  return (
    <section
      {...(id && { id })}
      className={classnames(
        className,
        'section relative overflow-clip',
        'space-y-14 px-4 md:px-10 lg:px-20 md:mb-20 mb-12',
      )}
    >
      {children}
    </section>
  );
}
